import { REGION_DISPLAY_ORDER, type LoungeRegion } from '../loungePassesConstants'
import AIRPORT_LOUNGE_INDEX from './airportLoungeIndex'
import CONTINENT_AIRPORT_INDEX from './continentAirportIndex'
import { sortLoungeIdsByRank } from './loungeOfferRankings'

const FEATURED_LOUNGES_PER_REGION = 4

/**
 * For each region, pick the highest-ranked lounge IDs from the ranked
 * airport lounge data.
 * Ranking correctness requires collecting every lounge in the region before
 * sorting; otherwise a lower-ranked airport encountered early could hide a
 * higher-ranked lounge later in the same region.
 *
 * This is a temporary solution — will be replaced when lounge data
 * includes region/country metadata from the experiences service.
 */
function getFeaturedLoungeIdsByRegion(): Record<LoungeRegion, Array<string>> {
  const result = {} as Record<LoungeRegion, Array<string>>
  for (const region of REGION_DISPLAY_ORDER) {
    const loungeIds: Array<string> = []
    for (const country of CONTINENT_AIRPORT_INDEX[region]) {
      for (const airport of country.airports) {
        const ids = AIRPORT_LOUNGE_INDEX[airport.id] ?? []
        loungeIds.push(...ids)
      }
    }
    result[region] = sortLoungeIdsByRank(loungeIds).slice(0, FEATURED_LOUNGES_PER_REGION)
  }
  return result
}

export default getFeaturedLoungeIdsByRegion
